export default class SelfInviteApi {
  constructor({ httpGet, httpPost, httpPut, httpDelete }) {
    this.httpGet = httpGet;
    this.httpPost = httpPost;
    this.httpPut = httpPut;
    this.httpDelete = httpDelete;
  }

  getSelfInvitedUsers(orgId, params, httpConfig) {
    return this.httpGet(`organisations/${orgId}/invitation/users`, params, httpConfig);
  }

  acceptSelfInvite(orgId, userId, params, httpConfig) {
    return this.httpPost(`organisations/${orgId}/invitation/user/${userId}`, params, httpConfig);
  }

  rejectSelfInvite(orgId, userId, params, httpConfig) {
    return this.httpDelete(`organisations/${orgId}/invitation/user/${userId}`, params, httpConfig);
  }

  getInviteSlug(orgId, params, httpConfig) {
    return this.httpGet(`organisations/${orgId}/invitation`, params, httpConfig);
  }

  requestOrgInvite(slug, userData, params, httpConfig) {
    return this.httpPost(`organisations/join/${slug}`, userData, params, httpConfig);
  }
}
